import React from "react";
import { cn } from "../../../lib/helpers";
import { Button } from "../../button";
import { PanelDetails, PlanPill } from "./pricing-plans";

export const PricingPlansSection = ({ section }) => {
  const plans = (section.plans || []).map((p) => ({
    ...p,
    planKey: p.planKey?.current || p.planKey,
  }));

  return (
    <div className="grid md:grid-cols-3 gap-12 sm:gap-2 lg:gap-4">
      {plans.map((p, i) => (
        <TierPanel plan={p} key={p._key || i} />
      ))}
    </div>
  );
};

const TierPanel = ({ plan }) => (
  <div className="rounded-xl border border-cardBorder bg-white p-4 lg:p-6">
    <div className="flex flex-col h-full">
      <div>
        <PlanPill title={plan.title} color={plan.color || "green-emerald"} />
      </div>
      <div className="pt-4 md:h-32 lg:h-24">
        <p className="text-3xl sm:text-2xl md:text-3xl font-semibold my-1">{plan.price}</p>
        <p className="leading-tight pb-4 text-auxiliary">
          {plan.priceDetails} {plan.actionDetails}
        </p>
      </div>
      <PanelDetails panel={plan} bgColor="dark-40" />
      <div className="mt-4 text-center flex-grow">
        <Button
          isBig={true}
          isJumbo={true}
          text={plan.ctaLabel}
          href={plan.ctaHref}
          bgColor={plan.ctaBgColor || "bg-black"}
          className={cn("w-full mb-4", plan.ctaClassName)}
          metrics={{ action: `pricing-${plan.planKey}` }}
        />
      </div>
    </div>
  </div>
);
